export type CatalogTemplateId = string;
export type CatalogTemplateUpdatePolicy = 'follow' | 'custom';
export type CatalogType = 'hero' | 'equipment' | 'pet';
export type CatalogTemplateSettings = {
  detailTemplate: CatalogTemplateId;
  templateSourceGame?: string;
  updatePolicy: CatalogTemplateUpdatePolicy;
  templateVersion: number;
  loadItemJson?: boolean;
  listShape?: 'square' | 'rectangle' | 'landscape';
  sourceMapping?: Partial<Record<'listPath' | 'id' | 'name' | 'dataUrl' | 'image' | 'type' | 'description' | 'detailName' | 'detailImage' | 'detailType' | 'detailDescription' | 'detailMode' | 'detailProjection' | 'relatedSource', string>>;
};

export const DEFAULT_CATALOG_TEMPLATE_VERSION = 1;
export const customHeroTemplateGames = new Set(['arcanatactics', 'rellion']);

export function normalizeCatalogTemplateSettings(
  value: unknown,
): CatalogTemplateSettings {
  const source =
    value && typeof value === 'object'
      ? (value as Partial<CatalogTemplateSettings>)
      : {};
  return {
    detailTemplate:
      typeof source.detailTemplate === 'string' &&
      /^[a-z0-9_-]+$/i.test(source.detailTemplate)
        ? source.detailTemplate
        : 'default',
    ...(typeof source.templateSourceGame === 'string' &&
    /^[a-z0-9_-]+$/i.test(source.templateSourceGame)
      ? { templateSourceGame: source.templateSourceGame }
      : {}),
    updatePolicy: source.updatePolicy === 'custom' ? 'custom' : 'follow',
    ...(typeof source.loadItemJson === 'boolean'
      ? { loadItemJson: source.loadItemJson }
      : {}),
    listShape: source.listShape === 'rectangle' || source.listShape === 'landscape' ? source.listShape : 'square',
    ...(source.sourceMapping && typeof source.sourceMapping === 'object'
      ? { sourceMapping: Object.fromEntries(Object.entries(source.sourceMapping)
        .filter(([key, path]) => ['listPath', 'id', 'name', 'dataUrl', 'image', 'type', 'description', 'detailName', 'detailImage', 'detailProjection', 'relatedSource', 'detailMode'].includes(key) && typeof path === 'string' && (key === 'detailMode' ? path === 'inline' : key === 'detailProjection' ? path === 'ournotes-v1' : /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*$/.test(path)))) } : {}),
    templateVersion:
      Number.isInteger(source.templateVersion) &&
      Number(source.templateVersion) > 0
        ? Number(source.templateVersion)
        : DEFAULT_CATALOG_TEMPLATE_VERSION,
  };
}

export function catalogTemplateSettingsFromGame(
  settings: Record<string, unknown>,
  catalogType: string = 'hero',
) {
  const catalog =
    settings.catalog && typeof settings.catalog === 'object'
      ? (settings.catalog as Record<string, unknown>)
      : {};
  const scopedSettings =
    catalog[catalogType] && typeof catalog[catalogType] === 'object'
      ? catalog[catalogType]
      : catalogType === 'hero'
        ? catalog
        : {};
  return normalizeCatalogTemplateSettings(scopedSettings);
}
